import { SectionHeading } from "@/components/vendor/Brand";

const FIELDS = [
  { id: "company_name", label: "Company name", autoComplete: "organization" },
  { id: "contact_name", label: "Contact name", autoComplete: "name" },
  { id: "email", label: "Email", type: "email", autoComplete: "email" },
  { id: "phone", label: "Phone", type: "tel", autoComplete: "tel" },
];

export const VendorInfoSection = ({ vendor, errors, onChange }) => (
  <section className="hx-section" data-testid="vendor-info-section">
    <SectionHeading>Vendor Information</SectionHeading>
    <div className="hx-grid">
      {FIELDS.map((f) => (
        <label key={f.id} className="hx-field" htmlFor={`vendor-${f.id}`}>
          <span className="hx-label">{f.label} <em>*</em></span>
          <input
            id={`vendor-${f.id}`}
            type={f.type || "text"}
            autoComplete={f.autoComplete}
            className={`hx-input ${errors[f.id] ? "is-invalid" : ""}`}
            value={vendor[f.id]}
            onChange={(e) => onChange(f.id, e.target.value)}
            aria-invalid={!!errors[f.id]}
            maxLength={f.id === "company_name" ? 150 : 120}
            data-testid={`vendor-${f.id.replace("_", "-")}-input`}
          />
          {errors[f.id] && <span className="hx-error" data-testid={`vendor-${f.id.replace("_", "-")}-error`}>{errors[f.id]}</span>}
        </label>
      ))}
    </div>
  </section>
);
